import React from 'react';

import HelpPage from './HelpPage';

async function action(context, params) {
  const { section } = params; // "the-basics", "help-for-shadowers", "help-for-experts", "trust-and-safety"
  return {
    title: 'Help',
    chunks: ['help'],
    component: <HelpPage section={section} />,
  };
}

export default action;
